import { HOSTS, ENDPOINTS } from "@/constants";
import { httpClient } from "@/services/httpClient";
import type { ContactState, RootState } from "@/types";
import type { ActionTree } from "vuex";
import {
  LOAD_CONTACT,
  LOAD_CONTACT_SUCCESS,
  LOAD_CONTACT_FAILURE,
  DELETE_CONTACT,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_FAILURE,
  ADD_CONTACT,
  ADD_CONTACT_SUCCESS,
  ADD_CONTACT_FAILURE,
  EDIT_CONTACT,
  EDIT_CONTACT_SUCCESS,
  EDIT_CONTACT_FAILURE,
} from "./mutations";

export const actions: ActionTree<ContactState, RootState> = {
  loadContacts({ commit }, params: any) {
    commit(LOAD_CONTACT);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.CONTACT}`, {
        params: {
          ...params,
        },
      })
      .then(
        (response: any) => {
          commit(LOAD_CONTACT_SUCCESS, {
            contacts: response.data,
            count: response.total_count,
          });
        },
        (error) => {
          commit(LOAD_CONTACT_FAILURE, error.response.data);
        },
      );
  },

  addContact({ commit }, contact: any) {
    commit(ADD_CONTACT);
    httpClient.post(`${HOSTS.AWS}/${ENDPOINTS.CONTACT}`, contact, {}).then(
      (response: any) => {
        commit(ADD_CONTACT_SUCCESS, response.data);
      },
      (error) => {
        commit(ADD_CONTACT_FAILURE, error.response.data);
      },
    );
  },

  editContact({ commit }, contact: any) {
    commit(EDIT_CONTACT);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.CONTACT}/${contact.id}`, {
        ...contact,
        id: undefined,
      })
      .then(
        (response: any) => {
          commit(EDIT_CONTACT_SUCCESS, response.data);
        },
        (error) => {
          commit(EDIT_CONTACT_FAILURE, error.response.data);
        },
      );
  },
  deleteContact({ commit }, contactId: string) {
    commit(DELETE_CONTACT);
    httpClient.delete(`${HOSTS.AWS}/${ENDPOINTS.CONTACT}/${contactId}`).then(
      () => {
        commit(DELETE_CONTACT_SUCCESS, contactId);
      },
      (error) => {
        commit(DELETE_CONTACT_FAILURE, error.response.data);
      },
    );
  },
};
